import { httpsCallable } from 'firebase/functions';
import { CloudFunctions } from '../utils/firebase/firebase';

export const getMyPatientsDetails = async (uid) => {
  try {
    const getMyPatients = httpsCallable(CloudFunctions, 'getMyPatients');

    const response = await getMyPatients({
      uid,
    });
    if (response.data.status) {
      return response.data.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const fetchPatientTreatments = async (uid, typeOfUser) => {
  try {
    const getPatientTreatments = httpsCallable(
      CloudFunctions,
      'getPatientTreatments'
    );

    const response = await getPatientTreatments({
      uid,
      typeOfUser,
    });
    if (response.data.status) {
      return response.data.treatments;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const updatePatientTreatmentDetails = async (
  uid,
  patientId,
  treatmentId,
  treatment
) => {
  try {
    const updatePatientTreatmentInfo = httpsCallable(
      CloudFunctions,
      'updatePatientTreatmentInfo'
    );

    const response = await updatePatientTreatmentInfo({
      uid,
      patientId,
      treatmentId,
      treatment,
    });
    if (response.data.status) {
      return response.data.message;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const addPatientByDoctor = async (uid, patientEmail) => {
  try {
    const addExistingPatientByDoctor = httpsCallable(
      CloudFunctions,
      'addExistingPatientByDoctor'
    );

    const response = await addExistingPatientByDoctor({
      uid,
      patientEmail,
    });
    console.log('response: ', response);

    if (response.data.status) {
      return response.data;
    } else {
      return response;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchDoctorAndPatientMessages = async (
  uid,
  doctorId,
  patientId,
  lastPatientCursor = null,
  lastDoctorCursor = null,
  limit = 15
) => {
  try {
    const getDoctorAndPatientMessages = httpsCallable(
      CloudFunctions,
      'getDoctorAndPatientMessages'
    );

    const response = await getDoctorAndPatientMessages({
      uid,
      doctorId,
      patientId,
      lastPatientCursor,
      lastDoctorCursor,
      limit,
    });

    if (response?.data?.status) {
      return {
        messages: response?.data?.data || [],
        lastPatientCursor: response?.data?.lastPatientCursor,
        lastDoctorCursor: response?.data?.lastDoctorCursor,
        hasMore: (response?.data?.data || []).length === limit,
      };
    } else {
      return {
        messages: [],
        lastPatientCursor: null,
        lastDoctorCursor: null,
        hasMore: false,
      };
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const fetchGroupMessages = async (uid, groupID) => {
  try {
    const getGroupMessages = httpsCallable(CloudFunctions, 'getGroupMessages');

    const response = await getGroupMessages({
      uid,
      groupID,
    });
    if (response.data.status) {
      return response.data.data;
    } else {
      return response;
    }
  } catch (e) {
    console.log(e);
    throw e;
  }
};